import { Component, OnInit, ViewChild, ElementRef, Input, Output, TemplateRef, Pipe, PipeTransform  } from '@angular/core';
import { MdSnackBar } from '@angular/material';
import { BsModalService, BsModalRef }  from 'ngx-bootstrap';
import { FormBuilder, FormGroup, FormControl, AbstractControl, Validators } from '@angular/forms';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/startWith';
import 'rxjs/add/operator/map';
import { Subject } from 'rxjs/Subject';
import { ToasterService } from 'angular2-toaster';
import swal from 'sweetalert2';
import * as _ from 'lodash';
import * as moment from 'moment';

import { ServiceWalkInService, CommonService, SubscribeService } from '../../../services/index';
import { ServiceWalkInModel } from '../../../model/index';

@Component({
    selector: 'add-serviceClient-window',
    templateUrl: './addServiceClient.component.html',
})
export class AddServiceClientComponent implements OnInit {
    private searchTerms = new Subject<string>();
    private searchTermsEmp = new Subject<string>();
    public resObj$ = new Subject();

    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;
    _params: any[] = [];
    @Input() set params(val: any[]) {
        this._params = val;
        this.setPageData();
    }

    public mode: string;
    public list: any[] = [];
    //public salesbilltypesdata: any[] = [];

    isLoadMask: Promise<any>;
    //salesbilltypesData: SalesBillentryModel[];
    isLoading: boolean = false;
    minDate: any;

    @Input() servicegriddata: ServiceWalkInModel[] = [];
    @Input() serviceClient: ServiceWalkInModel[] = [];
    partyCtrl: FormControl;
    typeCtrl: FormControl;
    modelCtrl: FormControl;
    filteredParty: Observable<any[]>;
    filteredModel: Observable<any[]>;
    PartyList = [];
    ModelList = [];
    typeList = [];
    actModelList = [];
    clientCtrl: FormControl;
    filteredItems: Observable<any[]>;

    @ViewChild('snoTemplate') snoTemplate: TemplateRef<any>;
    @ViewChild('editDeleteTemplate') editDeleteTemplate: TemplateRef<any>;
    @ViewChild('clientAutoComp') clientAutoComp;
    reorderable: boolean = true;
    page = {
        limit: 20,
        count: 0,
        offset: 0,
        orderBy: 'purchase_id',
        orderDir: 'asc'
    };
    columns = [];
    serviceClientDetails = [];
    clientList: any[] = [];

    constructor(private modalService: BsModalService,
                private ServiceWalkInService: ServiceWalkInService,
                private commonService: CommonService, 
                public snackBar: MdSnackBar,
                public toasterService: ToasterService,
                public bsModalRef: BsModalRef,
                public subscribeService: SubscribeService) {

        //this.halistCtrl = new FormControl();
          //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidParty(input: FormControl) {
            let partyID = input.value, retVal = null;
            if (partyID == "") {
                retVal = { inValidParty: true };
            }
            if (partyID && typeof partyID === 'string') {
                retVal = { inValidParty: true };
            }
            return retVal;
        }
        this.partyCtrl = new FormControl('', [
            Validators.required,
            hasValidParty.bind(this)
        ]);
        this.clientCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);
        this.filteredParty = this.partyCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterParty(name) : this.PartyList.slice());

        //FOR AUTO COMPLETE VALIDATION --- MODEL COMBO
        function hasValidModel(input: FormControl) {
            let brandID = input.value, retVal = null;
            if (brandID == "") {
                retVal = { inValidModel: true };
            }
            if (brandID && typeof brandID === 'string') {
                retVal = { inValidModel: true };
            }
            return retVal;
        }
        this.modelCtrl = new FormControl('', [
            Validators.required,
            hasValidModel.bind(this)
        ]);
        this.filteredModel = this.modelCtrl.valueChanges
            .startWith(null)
            .map(name => name ? this.filterModel(name) : this.ModelList.slice());

         //FOR AUTO COMPLETE VALIDATION --- BRAND MODEL
        function hasValidType(input: FormControl) {
            let ledgerID = input.value, retVal = null;
            if (ledgerID != "HA Model" && ledgerID != "Spare" ) {
                retVal = { inValidType: true };
            }
          
            return retVal;
        }
        this.typeCtrl = new FormControl('', [
            Validators.required,
            hasValidType.bind(this)
        ]);
    }

    ngOnInit(): void {
        let that = this;
     
        this.columns = [
            { name: 'SNo', prop: 'sno', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellTemplate: this.snoTemplate },
            { name: 'Type', prop: 'stock_type', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            { name: 'Model', prop: 'model_name', width: 220, minWidth: 220, maxWidth: 220, sortable: false, cellClass: 'cell-left' },
            { name: 'Brand', prop: 'brand_name', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-left' },
            { name: 'Serial No', prop: 'serial_no', width: 150, minWidth: 150, maxWidth: 150, sortable: false, cellClass: 'cell-left' },
            { name: 'Quantity', prop: 'act_qty', width: 110, minWidth: 110, maxWidth: 110, sortable: false, cellClass: 'cell-right' },
            { name: 'Action', prop: 'sno', width: 80, minWidth: 80, maxWidth: 80, sortable: false, cellClass: 'cell-center', cellTemplate: this.editDeleteTemplate }
        ];

        this.filteredItems = this.searchTerms
            .debounceTime(300)        // wait 300ms after each keystroke before considering the term
            .distinctUntilChanged()   // ignore if next search term is same as previous
            .switchMap(term => term   // switch to new observable each time the term changes
                // return the http search observable
                ? this.commonService.loadClientList(term, 'salesBillentry')
                // or the observable of empty heroes if there was no search term
                : Observable.of<any[]>([]))
            //.switchMap(term => this.commonService.loadClientList(term, 'tt'))
            .catch(error => {
                // TODO: add real error handling
                console.log(error);
                return Observable.of<any[]>([]);
            });

        this.filteredItems.subscribe(($e) => {
            that.clientList = $e;
        });

    
        
        //TO LOAD MODEL STOCK LIST
        this.loadStockModelList();
        this.typeList = ['HA Model', 'Spare'];
         
       
          //  this.loadAutoNumber();
            this.minDate = new Date(new Date().getFullYear(),
                new Date().getMonth(),
                new Date().getDate());
            this.serviceClient['date'] = new Date();
        

    }
     
     searchClient(query: string) {
        this.searchTerms.next(query);
    }

    loadStockModelList() {
        let that = this,
            data = {
                type: 'All',
                comp_stock: 'No'
            };
        this.commonService
            .getStockModelList(data)
            .then(function(res: any) {
                if (res.success) {
                    that.actModelList = res.data;
                    //that.ModelList = res.data;
                    //that.modelCtrl.setValue(that.serviceClient['model_id']);
                } else {
                    var toast = {
                        type: 'error',
                        title: 'ERROR',
                        body: 'Oops....Something Went Wrong'
                    };
                    that.toasterService.pop(toast);
                }
            });
    }

    onSelectedType(typeName) {
        
        this.ModelList = [];
        this.ModelList = _.filter(this.actModelList, { 'from_page': typeName });
        this.modelCtrl.setValue(this.serviceClient['model_id']);
    }
    displayFn(client_id: any) {
        if (this.clientList != undefined) {
            if (client_id && this.clientList.length > 0) {
                let fitem = _.find(this.clientList, { 'client_id': client_id });
                this.serviceClient['client_name'] = fitem.client_name; //ANOTHER FIELD
                this.serviceClient['mobile'] = fitem.mobile;
                this.serviceClient['age'] = fitem.age;
                this.serviceClient['reference'] = fitem.reference_name;
                this.serviceClient['client_no'] = fitem.client_no;
                //this.servicegriddata['ref_name'] = fitem.name; //ANOTHER FIELD
                return fitem['client_no'];
            }
        }
        return '';
    }
    filterParty(name: string) {
        name = _.escapeRegExp(name);
        return this.PartyList.filter(item => (new RegExp(name, 'gi').test(item.party_name)));
    }

    displayPartyFn(partyID: number) {
        if (partyID && this.PartyList.length > 0) {
            let fitem = _.find(this.PartyList, { 'party_id': partyID });
            return fitem['party_name'];
        }
        return '';
    }

    filterModel(name: string) {
        name = _.escapeRegExp(name);
        return this.ModelList.filter(item => (new RegExp(name, 'gi').test(item.model_id)
          || new RegExp(name, 'gi').test(item.name)  ));
    }

    displayModelFn(modelID: number) {
        if (modelID && this.ModelList.length > 0) {
            let fitem = _.find(this.ModelList, { 'model_id': modelID });
            if (fitem) {
                return fitem['color_name'] ? fitem['name'] + ' - ' + fitem['color_name'] : fitem['name'];
            }
        }
        return '';
    }

    onChangeModel(opt: any) {
        this.servicegriddata['model_name'] = opt['name'];
        this.servicegriddata['brand_name'] = opt['brand_name'];
        this.servicegriddata['color_name'] = opt['color_name'] || '';
    }

    onEnterKeyPressed(nextEl: string): void {
        if (_.isEmpty(document.getElementById(nextEl))) {
            nextEl = 'empid';
        }
        $('#' + nextEl).focus();
    }
     
    setPageData(): void {
        if (this._params != undefined) {
            let mode = this._params['mode'];
            this.serviceClient = Object.assign({}, this._params);
            if (mode == 'Add') {

               // this.getPurchaseInvoiceDetailList();
                this.serviceClient['date'] = new Date(this._params['date']);
            }
        }
    }
  

    onDeletePurchaseInvoiceEntry(row: any): void {
        let that = this,
            mode = this.serviceClient['mode'];

       
        if (mode == 'Add') {
            this.serviceClientDetails.splice(this.serviceClientDetails.indexOf(row), 1);
     
        }
      
    }

    addServiceClient(): void {
        let that = this,
            mode = this.serviceClient['mode'],
            modelID = this.servicegriddata['model_id'],
            modelName = this.servicegriddata['model_name'],
            serialNo = this.servicegriddata['serial_no'],
            stockType = this.servicegriddata['stock_type'];
        if (!_.isEmpty(_.toString(modelID))) {//} != undefined) {
            //IF preTestID FOUND, THAT ID IS ALREDAY AVAILABLE INSIDE TABLE
            let preTestID = _.find(this.serviceClientDetails, { 'model_id': modelID, 'serial_no': serialNo });

            if (preTestID) {
                swal('WARNING', 'Model : ' + modelName + ', Serial NO: ' + serialNo + ' Already Exists');
                return;
            }

            let actQty = this.servicegriddata['act_qty'];
            if (_.isEmpty(actQty)){ // 11 > 10
                swal('WARNING', 'Enter Quantity ');
                return;
            }
            
      
          if (mode == 'Add') {
                let testDet = Object.assign({}, that.servicegriddata);
                that.serviceClientDetails.push(testDet);
                that.servicegriddata = [];
                that.page.count = that.serviceClientDetails.length;
          
            }          
        }
    }

  calModel() {
        
        this.onSelectedType(this.servicegriddata['stock_type']);
    }

    
  //  bsModalRef: BsModalRef;
    onSaveServiceClient(): void {
        let that = this,
            mode = this.serviceClient['mode'],
            serviceCliententry = this.serviceClientDetails.length,
            qty = 0;
      
        if (serviceCliententry == 0) {
            swal('WARNING', 'No Data Found, <br> Please Add Model Details');
            return;
        }
       
        for (let i = 0; i < serviceCliententry; i++) {
            qty += parseFloat(this.serviceClientDetails[i].act_qty);
        }
        let serviceClientDate = moment(this.serviceClient['date']).format('YYYY-MM-DD'),
            data = {

                date: serviceClientDate,
                client_id: this.serviceClient['client_id'],
                client_no: this.serviceClient['client_no'],
                client_name: this.serviceClient['client_name'],
                //age: this.serviceClient['age'],
                mobile: this.serviceClient['mobile'],
                //address: this.serviceClient['address'],
                serviceClientDetails: JSON.stringify(this.serviceClientDetails),
                description: this.serviceClient['description'],
                mode: this.serviceClient['mode'],
                page_from: 'ServiceClient',
                tot_qty: qty,
                bill_id: null
            };
  
        that.isLoading = true;
        this.ServiceWalkInService
            .addSaveServiceClient(data)
            .then(function(res: any) {
                that.isLoading = false;
                if (res.success) {
                    that.serviceClient = [];
                    that.serviceClientDetails = [];
                    swal('SUCCESS', res.message, 'success');
                    that.bsModalRef.hide();
                    data.bill_id = res.bill_id;
                    that.subscribeService.setServiceClient(data);
                } else {
                    swal('ERROR', res.message, 'error');
                }
            })
            .catch(function(error: any) {
                that.isLoading = false;
                let res = JSON.parse(error._body);
                swal('ERROR', res.message, 'error');
                //console.log(error);
            });
    }

}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/transaction/serviceWalkIn/addServiceClient.component.ts